// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".characterization-radio-question--container {\n  display: flex;\n  gap: 17px;\n  flex-direction: column;\n  margin-left: 10px; }\n\n.characterization-radio-question--subtitle {\n  font-size: 50px;\n  margin-bottom: 15px; }\n  .characterization-radio-question--subtitle p {\n    margin-bottom: 0px !important; }\n", ""]);
// Exports
module.exports = exports;
